var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"issues-app-chat-sidebar-card",class:[
      ("issues-app-chat-sidebar-card_" + _vm.color)
    ]},[(_vm.$slots.header)?_c('div',{staticClass:"issues-app-chat-sidebar-card__header"},[_vm._t("header")],2):_vm._e(),_c('div',{staticClass:"issues-app-chat-sidebar-card__body"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }